import { IUpdateSubcontasUseCase } from "../../../presentation/useCases/update/update_subcontas_use_case";
import { IComercialRepository } from "../../repositories/comercial_repositories";

/**
 * UpdateSubcontasUseCase
 */

export class UpdateSubcontasUseCase implements IUpdateSubcontasUseCase {
  constructor(private readonly repository: IComercialRepository) { }

  async execute(
    idSubconta: number,
    ativo: boolean,
    idSubcontaPai?: number,
    codigo?: string,
    descricao?: string,
  ): Promise<void> {
    await this.repository.updateSubconta(
      idSubconta,
      ativo,
      idSubcontaPai,
      codigo,
      descricao,
    );

  }
}
